module.exports = __webpack_public_path__ + "media/images/plus-aefede665949702069957d851f40a058.png";